import { render, staticRenderFns } from "./RegiaoAnaliseTable.vue?vue&type=template&id=456fc980&lang=pug"
import script from "./RegiaoAnaliseTable.vue?vue&type=script&lang=js"
export * from "./RegiaoAnaliseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports